import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export default css`
  .dark-mode {
    color: ${themeGet('colors.dark-mode', '#2B2C32')};
  }
  .pc-red {
    color: ${themeGet('colors.pc-red', '#E1251B')};
  }
  .secondary-red {
    color: ${themeGet('colors.secondary-red', '#FF3300')};
  }
  .tertiary-red {
    color: ${themeGet('colors.tertiary-red', '#C2211C')};
  }
  .teal {
    color: ${themeGet('colors.teal', '#007A85')};
  }
  .secondary-teal {
    color: ${themeGet('colors.secondary-teal', '#00646d')};
  }
  .velvet {
    color: ${themeGet('colors.velvet', '#3D1952')};
  }
  .secondary-velvet {
    color: ${themeGet('colors.secondary-velvet', '#80348E')};
  }
  .tertiary-velvet {
    color: ${themeGet('colors.tertiary-velvet', '#552877')};
  }
  .white {
    color: ${themeGet('colors.white', '#FFFFFF')};
  }
  .black {
    color: ${themeGet('colors.black', '#000000')};
  }
  .main-text {
    color: ${themeGet('colors.main-text', '#2B2C32')};
  }
  .secondary-text {
    color: ${themeGet('colors.secondary-text', '#686868')};
  }
  .light-grey {
    color: ${themeGet('colors.light-grey', '#F6F6F7')};
  }
  .stone {
    color: ${themeGet('colors.stone', '#EBEDEB')};
  }
  .border-grey {
    color: ${themeGet('colors.border-grey', '#D8D8D8')};
  }
  .light-border-grey {
    color: ${themeGet('colors.light-border-grey', '#E8E9EB')};
  }
  .insiders-yellow {
    color: ${themeGet('colors.insiders-yellow', '#FFF200')};
  }
  .yellow {
    color: ${themeGet('colors.yellow', '#FBB600')};
  }
  .pink {
    color: ${themeGet('colors.pink', '#F9BBB4')};
  }
  .chart-pink {
    color: ${themeGet('colors.chart-pink', '#faecec')};
  }
  .purple {
    color: ${themeGet('colors.purple', '#D6CEDB')};
  }
  .brown {
    color: ${themeGet('colors.brown', '#191105')};
  }
  .holiday-red {
    color: ${themeGet('colors.holiday-red', '#e9c7b8')};
  }
  .holiday-green {
    color: ${themeGet('colors.holiday-green', '#bcd8e5')};
  }
  .pc-lilac {
    color: ${themeGet('colors.pc-lilac', '#EFDFF2')};
  }
  .joe-fresh-orange {
    color: ${themeGet('colors.joe-fresh-orange', '#EB6623')};
  }
  .joe-fresh-velvet {
    color: ${themeGet('colors.joe-fresh-velvet', '#3B1A51')};
  }

  p,
  span {
    .dark-mode,
    .pc-red,
    .secondary-red,
    .tertiary-red,
    .teal,
    .secondary-teal,
    .velvet,
    .secondary-velvet,
    .tertiary-velvet,
    .white,
    .black,
    .main-text,
    .secondary-text,
    .light-grey,
    .stone,
    .border-grey,
    .light-border-grey,
    .insiders-yellow,
    .yellow,
    .pink,
    .chart-pink,
    .purple,
    .brown,
    .holiday-red,
    .holiday-green,
    .pc-lilac {
      font-size: inherit;
      font-weight: inherit;
    }
  }
`;
